import { render, staticRenderFns } from "./TopNav.vue?vue&type=template&id=70f535dc&scoped=true&"
import script from "./TopNav.vue?vue&type=script&lang=js&"
export * from "./TopNav.vue?vue&type=script&lang=js&"
import style0 from "./TopNav.vue?vue&type=style&index=0&id=70f535dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f535dc",
  null
  
)

export default component.exports